<template>
  <!-- 가이드평가 -->
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      :retain-focus="false"
      content-class="bottom-sheet"
  >
    <v-card>
      <v-card-title>
        가이드 피드백
        <v-spacer />
        <v-btn icon @click="sheetOpen(false, sheetParams)">
          <Close/>
        </v-btn>
      </v-card-title>
      <v-card-text ref="card">
        <div class="text-area" v-html="sheetParams.feedback"></div>
      </v-card-text>
      <v-card-actions>
        <BlackBtn x-large :str="moveBtnText" v-if="disabledMoveBtn" @click="moveTo"></BlackBtn>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>
<script>
import Close from '@/components/icons/Close'
import BlackBtn from "@/components/btns/BlackBtn";
export default {
  data: () => ({
    sheet: false,
    sheetParams:{},
    guideFeedback: '가이드 피드백 내용 입니다. <br/>매일 매일 기록 하도록 노력해보세요',
  }),
  components: {
    Close,
    BlackBtn
  },
  computed: {
    moveBtnText() {
      const text = this.sheetParams.feedbackType==='travel'?"여행지원서":"미션"
      return `${text} 보러가기`
    },
    disabledMoveBtn() {
      return (this.sheetParams.travelApplStepCd || this.sheetParams.unitFdbNo)
    }
  },
  methods: {
    moveTo() {
      window.location.href = `#${this.sheetParams.id}#feedback`;
      if (this.sheetParams.feedbackType === 'travel') {
        this.$router.push({
          path: '/travelApplication/intro', query: {travelApplStepCd: this.sheetParams.travelApplStepCd, startType: 'S', showType: "FEEDBACK"}
        });
      } else {
        this.$router.push({path: '/fo/solution', query: {unitUseNo: this.sheetParams.unitUseNo, freeYn: 'N', cmpltYn: 'true'}});
      }
    },
    sheetOpen(flag, sheetParams) {
      this.sheet = flag;
      this.sheetParams = sheetParams;
      this.$vuetify.goTo(0, {container: this.$refs.card})
    }
  }
}
</script>
<style lang="scss" scoped>
.text-area {
  min-height: 210px;
  background: #F4F4F4;
  //overflow-y: auto;
  font-size: 14px;
  color: #101010;
  border-radius: 6px;
  padding: 16px;
}
</style>
